export default "__VITE_ASSET__DRcP_7kt__"